
export let Translate = {
  en: {
    search: 'Search',
    delete: 'Delete',
    delete_confirm: 'Are you sure you want to delete this item?',
    close: 'Close',
    save: 'Save',
    add: 'Add',
    edit: 'Edit',
    export: 'Export',
    actions: 'Actions',
    cancel: "Back",//for cancel booking, "cancel" is confused. changed to "back".
    confirm: 'Confirm',
    email: 'Email',
    name: 'Name',
    code: 'Code',
    username: 'Username',
    date: 'Date',
    time: 'Time',
    member: 'Member',
    password: 'Password',
    change_password: 'Change Password',
    logout: "Logout",
    login: "Login",
    optional: "Optional",
    share: "Share",
    linkCopied: "Link Copied",
    copied: "Copied",
    other_language: 'Other Languages',
    enable: 'Enable',
    disable: 'Disable',
    active: "Active",
    inactive: "Inactive",
    no_result: "No matched results",
    change: "Change",
    day: 'day(s)',
    or: 'or',
    next: 'Next',
    back: 'Back',
    pls_select: 'Please Select',
    duplicate: 'Duplicate',
    na: 'N/A',
    copy_instruction: 'Copy the below text',
    copy_selected: 'Text selected',
    On: 'On',
    Off: 'Off',

    en: 'English',
    zh_cn: 'Simplified Chinese',

    pagenotfound: 'Page Not Found',
    notfound_exp:
      'The page you are looking for does not exist. It might have been moved or deleted.',
    user_notfound: 'User Not Found',
    backhome: 'Back to Homepage',
    show_more: 'Show more',
    hide: 'Hide',

    //error message
    error: {
      'integrity.error': 'Cannot Delete: It already linked with other items',
      'already.accepted': 'You have already accepted this invitation and cannot accept it again.',
      'capacity.exceeded': 'Unable to accept the invitation, the event has reached the maximum number of participants alloweded.',
      'booking.cancelled': 'The booking has been cancelled, unable to perform this action.',
      'booking.ended': 'The booking has ended, unable to perform this action.',
      'not.available': 'This time slot is no longer available for booking. Please reselect.',
      'duplicate.bookings': 'Cannot book the same time slot multiple times',
    },

    thinkdesks: {
      Yes: "Yes",
      No: "No",
      time: "Time",
      duration: "Duration",
      set_special_day: "Set Special Day",
      open: "Open",
      public_holiday_open: "Public Holiday has different opening hours?",
      closed: "Closed",
      special_day: 'Special Day',
      set_schedule: "Set Schedule",
      from: "From",
      from_placeholder: "Effective date (Required)",
      to: "To",
      to_placeholder: "Leave it blank if until forever",
      schedule_info: "Schedule Info",
      copy_to: "Copy To",
      select_all: "Select All",
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat",
      sun: "Sun",
      public_holiday: "Public Holiday",
      regular_schedule: 'Regular Schedule',
      selected_day: "Selected Day",
      special_in_use: "Special In Use",
      onwards: "Onwards",
      applicable_date: "Applicable Date",

      //error message
      exceed_booking_hour: "Maximum session per booking is",
    },

    schecule_applied_space: "Space Applied",



    interval: {
      days: 'day(s)',
      hour: 'hr',
      hours: 'hrs',
      mins: 'mins',
      secs: 'secs',
      from: 'From',
      to: 'to',
    },


    filterObject: {
      _: 'Selections in Filters',
      all_time: 'All Time',
      today: 'Today',
      yesterday: 'Yesterday',
      day3: 'Last 3 Days',
      day14: 'Last 14 Days',
      day7: 'Last 7 Days',
      custom_time: 'Custom',
      Contains: 'contains',
      EndsWith: 'ends With',
      greaterThan: 'greater than',
      lessThan: 'less than',
      lessThan_equal: 'less than/equal to',
      greaterThan_equal: 'greater than/equal to',
    },

    //Menu//
    Home: "Home",
    SpaceBookings: 'Space Booking',
    favourites_space: 'My Favourites',
    MyBookings: 'My Bookings',
    Profile: "Profile",
    AllCenters: "Center List",
    MyCenters: "My Centers",
    MySpaces: "My Spaces",
    Centers: "Centers",
    Spaces: 'Spaces',
    Space: "Space",
    BookingManagement: "Manage Bookings",
    Manage: "Manage",

    //Home//
    HomeGreeting1: "Hello!",
    HomeGreeting2: "Finding Space?",
    NearbyCenters: "Nearby Centers",
    Centers_random: "Centers",
    ViewMap: "View Map",
    ViewAll: "View All",
    RecommendedSpaces: "Recommended Spaces",
    SearchSpaces: "Search Spaces",

    //Status//
    bookingStatus: {
      status: 'Status',
      pending: 'Pending',
      cancelled: 'Cancelled',
      approved: 'Confirmed',
      rejected: 'Rejected',
    },

    //My bookiong//
    UpComing: "Upcoming",
    Past: "Past",
    AddToCalendar: "Add To Calendar",
    CenterInfo: "Center Info",
    Remarks: "Remarks",
    SpaceFacilities: "Space Facilities",
    FacilitiesIncluded: "Facilities Included",
    AdditionalFacilitiesAvailableForRent: "Additional Facilities Available",
    RebookSameSpace: "Book the same room again",
    AdditionalFacilities: " Additional Facilities",

    //blacklist//
    booking_blacklist: "Due to your absence from more than 2 bookings, the system has temporarily blocked your booking functionality. If you need assistance, please contact the center staff.",
    manually_by: "Manually by",

    //SpaceCard//
    Capacity: "Capacity",
    VenueSize: "Space Size",
    People: " ppl.",

    //Booking dialog//
    Booking: 'Booking',
    sync_to_VP: 'Sync to VP',
    LockerBooking: 'Locker Booking',
    NotSelected: 'Not Selected',
    SelectMember: 'Select Member',
    StartTime: 'Start Time',
    Duration: 'Duration',
    Book: 'Book',
    Status: 'Status',
    BookSpace: 'Book Space',
    Lockers: 'Lockers',
    Locker: 'Locker',
    Listview: 'List view',
    Calendarview: 'Calendar view',
    Selectspacebook: 'Select the space you want to book',
    Pending: 'Pending',
    Rejected: 'Rejected',
    Approved: 'Approved',
    Cancelled: 'Cancelled',
    SetSpecialDay: 'Set Special Day',
    SetSchedule: 'Set Schedule',
    RegularSchedule: 'Regular Schedule',
    SpecialDay: 'Special Day',
    ApplicableDate: 'Applicable Date',
    Onwards: 'Onwards',
    Selectedday: 'Selected',
    SpecialInuse: 'Special In use',
    Closed: 'Closed',
    From: 'From',
    To: 'To',
    ScheduleInfo: 'Schedule Info',
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
    Holiday: 'Holiday',
    CopyTo: 'Copy To',
    SelectAll: 'Select All',
    Open: 'Open',
    BookingDetails: "Booking Details",
    Sync: "Sync",
    DoYouNeedToRentAnyAdditionalFacilities: "Do you want additional facilities?",
    Yes: "Yes",
    No: "No",
    BookingPerson: "Booking Person",
    ContactPerson: "Contact Person",
    SameAsBookingPerson: "Same as Booking Person",
    SelectDateAndTime: "Select Date and Time",
    SelectTime: "Please select time",
    time_available: "Available",
    time_unavailable: "Unvailable",
    time_selected: "Selected",
    available_qty: "Available",
    ConfirmTitleText: "Please confirm the following booking details!",
    DateAndTime: "Date and Time",
    TermsAndConditions: "Terms and Conditions",
    TermsAndConditions_space: "Space Booking Terms and Conditions",
    TermsAndConditions_space_exp: "If leave this field empty, Center default/System default T&C will be applied.",
    TermsAndConditions_centerDefault: "Booking Terms and Conditions (Center Default)",
    TermsAndConditions_centerDefault_exp: "If the Space have no T&C, the following Center default T&C will be applied. If leave this field empty, System default will be applied.",
    BookingConfirmed: "Booking Confirmed",
    waitApproval: "Please wait for approval",
    QRCodeText1: "Please check-in by scaning your",
    QRCodeText2: "membership QR code",
    usePasscode: 'use the following passcode',
    participant_users: 'user(s)',
    participant: 'Participant',
    walkin: 'Participant(Walk-in)',
    numParticipants: 'Number of Participants',
    numParticipants_exp: 'If this room will not be shared with other users, please enter 0.',
    numParticipants_max1: '*Maximum',
    numParticipants_max2: 'participants allowed',
    numParticipants_error_neg: 'Please enter a positive number for participants',
    numParticipants_error_exceed: 'Number of participants exceed the limit',
    numParticipants_list: 'Participant List',
    numParticipants_list_na_capacity: 'Space capacity setting is 1. Participant list is not applicable.',
    numParticipants_list_na_maxBookings: 'Multi-seat Reservation per Time Slot is on for this space. Participant list is not applicable.',
    numParticipants_edit: 'Edit Number of Participants',
    numParticipants_edit_error: 'Unable to modify the number of participants; the room has reached its maximum capacity.',
    walkin_list: 'Participant (Walk-in) List',
    walkin_list_na_capacity: 'Space capacity setting is 1. Participant (Walk-in) list is not applicable.',
    walkin_list_na_maxBookings: 'Multi-seat Reservation per Time Slot is on for this space. Participant (Walk-in) list is not applicable.',
    booking_participant_reminder: 'You can present your personal E-Passport (Member Qr Code) to unlock this room and check in during your reserved time slot.',

    //Booking invitation//
    login_tomo: 'Please log in to your TO_MO account first',
    open_tomo_app: 'Open the TO_MO APP',
    tomo_app_not_installed: "Don't have the TO_MO APP yet?",
    download_now: 'Download now',
    or_webLogin: 'Or log in via the website',
    webLogin: 'Log in via the website',
    invite_you: ' is inviting you to participate in the following evnet',
    invite_reminder: 'If you accept the invitation, it will appear in your personal booking record page, which you can view at any time. After accepting the invitation, you can unlock the room and check-in via your personal E-Passport for the reserved time slot.',
    invite_accept: 'Accept',
    invite_owner_error: 'You cannot accept your own invitation',
    invite_ended_error: 'The event has ended',
    invite_cancelled_error: 'The event has been cancelled',
    invite_exceeded_error: 'The event has reached the maximum number of participants alloweded',
    invite_outsider_error: 'Sorry! You are not eligiable for using this reservation system. Could not participate in room booking.',

    //Booking dialog - snackbar//
    select_date_alert: "Please select Date and Time",
    select_facility_alert: "Please select facility",

    //Center//
    space_facilities: "Space Facilities",
    AddCenter: "Add Center",
    viewAllCenters: "View all centers",
    Introduction: "Introduction",
    ContactInfo: "Contact Info",
    Area: "Area",
    HK: "Hong Kong Island",
    KLN: "Kowloon",
    NT: "New Territories",
    HK_CS: "Central and Western",
    HK_WC: "Wan Chai",
    HK_E: "Eastern",
    HK_S: "Southern",
    KLN_YTM: "Yau Tsim Mong",
    KLN_SSP: "Sham Shui Po",
    KLN_KC: "Kowloon City",
    KLN_WTS: "Wong Tai Sin",
    KLN_KT: "Kwun Tong",
    NT_KT: "Kwai Tsing",
    NT_TW: "Tsuen Wan",
    NT_TM: "Tuen Mun",
    NT_YL: "Yuen Long",
    NT_N: "North",
    NT_TP: "Tai Po",
    NT_ST: "Sha Tin",
    NT_SK: "Sai Kung",
    NT_Islands: "Islands",
    address: "Address",
    tel_no: "Tel No.",
    center_contact_person: "Center Contact Person",
    opening_hours: "Opening Hours",
    map_settings: "Map Settings",
    google_map_url: "Google Map URL",
    google_map: "Google Map",
    latitude: "Latitude",
    longitude: "Longitude",
    Categories: "Categories",
    DefualThemes: "Defult Themes",
    Schedules: 'Schedules',
    Schedules_copy: 'Duplicate Schedule',
    Schedules_copy_confrim: 'Confirm to duplicate ',
    PublicHolidayCalendar: "Public Holiday Calendar",
    Settings: 'Settings',
    Locations: "Locations",
    Location: "Location",
    center: "Center",
    organization: "Organization",
    Min: 'Min',
    Max: 'Max',
    Mins: "Mins",
    Events: "Events",
    Event: "Event",
    Bookings: "Bookings",
    ViewDetails: "View Details",
    email_alert: "System Email Alert",
    email_recipients: "Recipients",
    email_recipients_exp: "Separate multiple emails with commas",
    email_lang: "Email Language",
    backtoHome: "Back to Home",

    //Locker//
    Code: 'Code',
    DeviceCode: 'Device Code:',
    TextDescription: 'Text Description',
    BookingSettings: 'Booking Settings',
    Calendar: 'Calendar',
    images: 'Images',
    Active: 'Active',
    ManualApproval: 'Manual Approval',
    Locked: 'Locked',
    Cells: 'Cells',

    //Member//
    ChineseName: 'Chinese Name',
    PolicyChecked: 'Policy Checked',
    Locale: 'Locale',
    English: 'English',
    Chinese: 'Chinese',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    AccessRight: 'Access Right',
    Roles: 'Roles',
    ResetPassword: 'Reset Password',
    MyPass: 'My QR Code Pass',

    //Member GP//
    MemberGPname: 'Member Group Name',


    //Space//
    AddSpace: 'Add Space',
    EditSpace: 'Edit Space',
    AutoApprove: 'Auto Approve',
    Bookable: 'Bookable',
    Dependencies: 'Dependencies',
    Facilities: 'Facilities',
    Type: 'Type',
    FacilityName: 'Facility Name',
    Space_rental: 'Spaces',
    OtherFacilities: 'Other Facilities',
    space_available: 'Space available',
    space_categories: "Space Categories",
    space_usage_theme: "Space Usage Theme",
    backtoCenter: "Back to Center",
    no_space: "We are preparing! No space available yet.",
    //SpaceType//
    AddSpaceType: 'Add Space Type',
    EditSpaceType: 'Edit Space Type',

    //Space - 21C//
    active_space: "Active Space",
    total_space: "All Space",
    add_Theme: "Add Theme",
    editTheme: "Edit Theme",
    addcategory: "Add Category",
    editcategory: "Edit Category",
    add_space: "Add Space",
    space_settings: "Space Settings",
    basic_settings: "Basic Settings",
    advanced_settings: "Advanced Settings",
    space_name: "Space Name",
    remarks: "Remarks",
    capacity: "Capacity",
    capacity_exp: "The capacity will limit the total number of participants can be invited. If left blank or input '0', it indicates that number of participants is unlimited.",
    booking_qty_title: "Multi-seat Reservation per Time Slot",
    booking_qty_title2:
      "(Suitable for room seat capacity management, e.g. study rooms)",
    booking_qty: "Quota per time slot",
    booking_qty_min_alert: "Must be at least 2 when enabled",
    booking_qty_capacity_alert: "Must be less than or equal to space capacity",
    booking_qty_exp:
      "Each person can only book this space once for the same time slot.",
    booking_qty_walkin_disabled:
      "When enabled, participant feature is not available for this space.",
    venue_size: "",
    facilities_included: "Facilities Included",
    additional_facilities_available_for_rent:
      "Additional Facilities Available For Rent",
    no_facility_found:
      "No additional facility available for spaces under this center",
    booking_settings: "Booking Settings",
    defual_space_usage_themes: "Defual Space Usage Themes",
    usage_theme: "Theme",
    booking_restrict: "Booking Restrictions",
    no_restrict_staff: "Center staff accounts have no restrictions",
    days_in_advance: "Future Booking Allowed",
    no_slot_available: 'No Available Slot',
    min: "Min",
    max: "Max",
    increment: "Increment",
    mins: "Mins",
    space_status: "Space Status",
    auto_approve: "Auto Booking Approval",
    auto_approve_exp:
      "If turned ON, center staff do not need to manually approve bookings. When a member submits a booking request, it will be automatically confirmed.",
    auto_approve_on: "Auto Booking Approval: OFF",
    auto_approve_off: "Auto Booking Approval: ON",
    staff_only: "Staff Only",
    staff_only_exp:
      "If turned ON, space booking will only be availabe to center staff.",
    booking_mode: "Booking Mode",
    booking_mode_exp:
      "This space does not require a booking. Center staff can access the space at any time; other members can access the space during open hours (if open hours are set).",
    door_lock_settings: "Door Lock Settings",
    smart_lock: "Smart Lock",
    booking_Records: "Booking Records",
    calendar: "Calendar",
    event: "Event",
    public_holiday_calendar: "Public Holiday Calendar",
    duration: "Duration",
    space_facility: "Space Facility",
    space_facility_add: "Add Space Facility",
    space_delete_locked: "This space is connected to a smart door lock. Cannot be deleted.",
    calendar_delete_locked: "This schedule is connected to a smart door lock. Cannot be deleted.",

    //Facility
    Facility: {
      pricing: "Facility Rental Fee",
      free: "Borrow for free",
      fee: "Fee required",
      input: "Input cost",
      reminder: "Due to the limited quantity of facility at the center, the facility you have selected does not guarantee a reservation. Arrangements will be made by the center staff. If you have any questions, please contact the center.",
    },


    //User//
    User: 'User',
    AdminUser: 'Admin User',
    user_type: "User Type",

    //Booking//
    created_time: 'Created Time',
    booked_slot: 'Booked Slot',
    approve: 'Approve',
    reject: 'Reject',
    booking_approval: 'Booking Approval',
    checkin: 'Checkin',
    absent: 'Absent',
    invite_frd: 'Invite friends to unlock/use the space',
    copy_invite_msg: 'Copy Invitation Message',
    share_whatsapp: 'Share to WhatsApp',
    cancel_booking: 'Cancel Booking',
    cancel_booking_confirm: 'Are you sure you want to cancel this booking?',
    cancel_booking_reason: {
      reason: 'I want to cancel the booking, the reason is:',
      event_cancelled: 'The event has been cancelled',
      incorrect_booking: 'The booking information is wrong',
      unexpected_matter: 'I have an emergency',
      other_location: 'I have another more suitable venue',
      other: 'Other reasons, please specify',
      other_reason: 'Reasons for cancelling the booking',
    },
    cancel_booking_byStaff: 'Booking cancelled by center staff',
    booking_remind_msg: {
      days_after1: 'Will be start in',
      days_after2: 'day(s)!',
      starting_soon: 'Starting soon!',
      checkin_now: 'Checkin now',
      checkin_done: 'Booking Checked in',
      checkin_no: 'No booking checkin record',
    },
    export_booking: 'Export Booking Records',
    export_booking_desc: 'Export booking records of the space in the selected date range:',
    export_booking_incl_checkin: "Include participants check-in records",
    export_booking_incl_checkin_alrt:
      "Enabling this may incure loger loading times.",
    select_booking: 'Select Booking',


    //Doors//
    locks_control: 'Door Locks',
    passcode: 'Passcode',
    door_log: 'Access Log',
    checkin_log: 'Checkin Log',
    tablet_control: 'Tablet Control',
    tablet: 'Tablet',
    poster_display: 'Poster Display',
    file_name: 'File Name',
    delete_file: 'Delete File',
    unlock: 'Unlock',


    Filter: {
      filter: 'Filter',
      all: 'All',
      district: 'District',
      cat_name: 'Category',
      cat_all: 'All Categories',
      capacity: 'Capacity',
      noSpecify: 'Not Specified',
      org_name: 'Organization',
      center_name: 'Center',
      clear: 'Clear',

      any_area: 'Any Area',
      any_district: 'Any Districts',
      date: 'Date/Time',

    },

    findSpace: {
      whatActivity: "What is your upcoming activity?",
      where: "Where the activity will take place?",
      ppl: "How many people will be attending the event?",
      when: "What time is the activity?",
      notDecided: "Not decided yet",
      ppl_above_zh: "",
      ppl_above_en: "Over",
      select_date: "Select a date",
      start_time: "Start Time",
      any_time: "Any Time",
      search_result: "Search Result",
      search_again: "Search Again",

      //error
      error_selectOne: "Please select at least one option",
    },



  },
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  zh_hk: {
    search: '搜尋',
    delete: '刪除',
    delete_confirm: '您確定要刪除此項目嗎？',
    close: '關閉',
    save: '儲存',
    add: '新增',
    edit: '編輯',
    export: '匯出',
    actions: '動作',
    cancel: "返回",//for cancel booking, "cancel" is confused. changed to "back"
    confirm: '確認',
    email: '電郵',
    name: '名稱',
    code: '編號',
    username: '用戶名稱',
    date: '日期',
    time: '時間',
    member: '會員',
    locker_bookings: '儲物櫃預約',
    password: '密碼',
    change_password: '更改密碼',
    logout: "登出",
    login: "登入",
    optional: "選填",
    share: "分享",
    linkCopied: "已複製連結",
    copied: "已複製",
    other_language: '其他語言',
    enable: '啟用',
    disable: '停用',
    active: "生效",
    inactive: "無效",
    no_result: "沒有乎合的結果",
    change: "更改",
    day: '日',
    or: '或',
    next: '下一步',
    back: '上一頁',
    pls_select: '請選擇',
    duplicate: '複製',
    na: '不適用',
    copy_instruction: '複製以下文字',
    copy_selected: '已選擇文字',
    On: "開啓",
    Off: "關閉",

    en: '英文',
    zh_cn: '簡體中文',

    pagenotfound: '找不到頁面',
    notfound_exp: '您要查找的頁面不存在。 它可能已被移動或刪除。',
    user_notfound: '找不到用戶',
    backhome: '回到主頁',
    show_more: '顯示更多',
    hide: '隱藏',


    //error message
    error: {
      'integrity.error': '不能刪除：此項目與其他項目有連結',
      'already.accepted': '您已曾經接受此活動邀請，無法重複接受。',
      'capacity.exceeded': '無法接受邀請，此活動已達房間可容納人數上限。',
      'booking.cancelled': '預約已取消，無法進行此操作。 ',
      'booking.ended': '預約已結束，無法進行此操作。 ',
      'not.available': '此時段已無法預約，請重新選擇。',
      'duplicate.bookings': '預約人不可重覆預約同一時段',
    },

    thinkdesks: {
      Yes: "是",
      No: "否",
      time: "時間",
      duration: "時長",
      set_special_day: "設置特殊日子",
      open: "開放時間",
      public_holiday_open: "公眾假期有不同開放時間?",
      closed: "休息",
      special_day: '特殊日子',
      set_schedule: "設置時間表",
      from: "由",
      from_placeholder: "生效日期(必填)",
      to: "至",
      to_placeholder: "如直至永遠，請留空",
      schedule_info: "時間表資訊",
      copy_to: "複製至",
      select_all: "全選",
      mon: "週一",
      tue: "週二",
      wed: "週三",
      thu: "週四",
      fri: "週五",
      sat: "週六",
      sun: "週日",
      public_holiday: "公眾假期",
      regular_schedule: '常規時間表',
      selected_day: "已選擇日期",
      special_in_use: "正使用特殊開放時間",
      onwards: "起",
      applicable_date: "適用日期",

      //error message
      exceed_booking_hour: "每次最多預約",
    },

    schecule_applied_space: "已套用房間",

    interval: {
      days: '日',
      hours: '小時',
      hour: '小時',
      mins: '分鐘',
      secs: '秒',
      from: '由',
      to: '至',
    },


    filterObject: {
      _: '篩選項目',
      all_time: '所有日期',
      today: '今天',
      yesterday: '昨天',
      day3: '最近3天',
      day14: '最近14天',
      day7: '最近7天',
      custom_time: '自訂',
      greaterThan: '大於',
      lessThan: '小於',
      lessThan_equal: '小於/等於',
      greaterThan_equal: '大於/等於',
    },

    //Menu//
    Home: "主頁",
    SpaceBookings: '房間預約',
    favourites_space: '我的最愛',
    MyBookings: '我的預約',
    Profile: "我的帳戶",
    AllCenters: "中心一覽",
    MyCenters: "我的中心",
    MySpaces: "我的房間",
    Centers: "中心",
    Spaces: "房間",
    Space: "房間",
    BookingManagement: "管理預約",
    Manage: "管理",

    //Home//
    HomeGreeting1: "Hello!",
    HomeGreeting2: "想搵咩地方?",
    NearbyCenters: "附近中心",
    Centers_random: "各區中心",
    ViewMap: "查看地圖",
    ViewAll: "查看全部",
    RecommendedSpaces: "推薦房間",
    SearchSpaces: "搜尋房間",

    //Status//
    bookingStatus: {
      status: '預約狀態',
      pending: '待批核',
      cancelled: '已取消',
      approved: '已確認',
      rejected: '已拒絕',
    },

    //My bookiong//
    UpComing: "近期預約",
    Past: "過往預約",
    AddToCalendar: "新增到日曆",
    CenterInfo: "中心資料",
    Remarks: "備註",
    FacilitiesIncluded: "已包括設備",
    SpaceFacilities: "房間設備",
    AdditionalFacilitiesAvailableForRent: "可額外借用設備",
    RebookSameSpace: "預約相同房間",
    AdditionalFacilities: "額外借用設備",

    //blacklist//
    booking_blacklist: " 由於你已缺席了超過2次或以上的房間預訂，系統暫時封鎖了你的預訂功能，如需幫忙請聯絡中心職員查詢。",

    //SpaceCard//
    Capacity: "可容納",
    VenueSize: "面積",
    People: "人",

    //Booking dialog//
    Booking: '預約',
    sync_to_VP: '同步到VP',
    NotSelected: '未選擇',
    SelectMember: '選擇會員',
    StartTime: '選擇時間',
    Duration: '租借時長',
    Book: '預約',
    Status: '狀態',
    BookSpace: '預約房間',
    Lockers: '儲物櫃',
    Listview: '列表檢視',
    Calendarview: '日曆檢視',
    Selectspacebook: '選擇預約房間',
    Pending: '待批核',
    Rejected: '拒絕',
    Approved: '已批核',
    Cancelled: '已取消',
    SetSpecialDay: '設定特別日子',
    SetSchedule: '設定日程',
    RegularSchedule: '平常日子',
    SpecialDay: '特別日子',
    ApplicableDate: '生效日期由',
    Onwards: '開始',
    Selectedday: '已選日期',
    SpecialInuse: '特別使用時間',
    Closed: '不開放',
    From: '由',
    To: '至',
    ScheduleInfo: '日程詳細',
    Mon: '星期一',
    Tue: '星期二',
    Wed: '星期三',
    Thu: '星期四',
    Fri: '星期五',
    Sat: '星期六',
    Sun: '星期日',
    Holiday: '公眾假期',
    CopyTo: '複製至',
    SelectAll: '全選',
    Open: '開放',
    BookingDetails: "預約詳情",
    Sync: "同步",
    DoYouNeedToRentAnyAdditionalFacilities: "是否需要借用額外設備",
    Yes: "是",
    No: "否",
    BookingPerson: "預約人",
    ContactPerson: "聯絡人",
    SameAsBookingPerson: "與預約人相同",
    SelectDateAndTime: "選擇日期及時間",
    SelectTime: "請選擇時段",
    time_available: "可選",
    time_unavailable: "不可選",
    time_selected: "已選",
    available_qty: "可預約",
    DateAndTime: "日期及時間",
    ConfirmTitleText: "請確認以下預約資料！",
    TermsAndConditions: "條款及細則",
    TermsAndConditions_space: "房間預約條款及細則",
    TermsAndConditions_space_exp: "如留空此欄，將會默認使用中心預設/系統預設條款及細則。",
    TermsAndConditions_centerDefault: "預約條款及細則 (中心預設)",
    TermsAndConditions_centerDefault_exp: "當房間沒有設定條款及細則，會默認使用此中心預設條款及細則。如留空此欄，將會默認使用系統預設條款及細則。",
    BookingConfirmed: "已完成預約",
    waitApproval: "我們會儘快批核你的預約，請耐心等候。",
    QRCodeText1: "請在簽到時出示",
    QRCodeText2: "會員QR Code",
    usePasscode: '透過以下密碼開門',
    participant_users: '使用者',
    participant: '參與者',
    walkin: '參與者(Walk-in)',
    numParticipants: '參與者人數',
    numParticipants_accepted: '參與者人數',
    numParticipants_exp: '若此房間不會與其他使用者共用，請填寫為 0。',
    numParticipants_max1: '*最多可邀請',
    numParticipants_max2: '位參與者使用房間',
    numParticipants_error_neg: '請輸入正確的參與者人數',
    numParticipants_error_exceed: '參與者人數超出上限',
    numParticipants_list: '參與者名單',
    numParticipants_list_na_capacity: '房間設定可容納人數為 1，參與者名單不適用。',
    numParticipants_list_na_maxBookings: '房間設定每時段可多座位預約，參與者名單不適用。',
    numParticipants_edit: '修改人數',
    numParticipants_edit_error: '無法修改參與者名單人數，已達房間最大可容納人數',
    walkin_list: '參與者(Walk-in)名單',
    walkin_list_na_capacity: '房間設定可容納人數為 1，參與者(Walk-in)名單不適用。',
    walkin_list_na_maxBookings: '房間設定每時段可多座位預約，參與者(Walk-in)名單不適用。',
    booking_participant_reminder: '您可予預約時段出示個人E-Passport（會員Qr Code）解鎖此房間並進行簽到。',

    //Booking invitation//
    login_tomo: '請先登入你的TO_MO賬戶',
    open_tomo_app: '開啓TO_MO APP',
    tomo_app_not_installed: '尚未有TO_MO APP？',
    download_now: '立即下載',
    or_webLogin: '或使用網站登入',
    webLogin: '網站登入',
    invite_you: '邀請你參與以下活動',
    invite_reminder: '如接受邀請會出現於你的個人預約，你可以隨時查看。 接受邀請後，即可予預約時段透過個人E-Passport解鎖房間並進行簽到。',
    invite_accept: '接受',
    invite_owner_error: '不能接受自己的活動邀請',
    invite_ended_error: '活動已結束',
    invite_cancelled_error: '活動已被取消',
    invite_exceeded_error: '此活動已達房間可容納人數上限',
    invite_outsider_error: '抱歉，您不是此預約系統的服務對象，所以未能參與房間預訂',



    //Booking dialog - snackbar//
    select_date_alert: "請選擇日期及時間",
    select_facility_alert: "請選擇房間設備",





    //Center//
    space_facilities: "房間設備",
    AddCenter: "新增中心",
    viewAllCenters: "查看全部中心",
    introduction: "介紹",
    ContactInfo: "聯絡資料",
    Area: "地區",
    HK: "港島",
    KLN: "九龍",
    NT: "新界",
    HK_CS: "中西區",
    HK_WC: "灣仔",
    HK_E: "東區",
    HK_S: "南區",
    KLN_YTM: "油尖旺",
    KLN_SSP: "深水埗",
    KLN_KC: "九龍城",
    KLN_WTS: "黃大仙",
    KLN_KT: "觀塘",
    NT_KT: "葵青",
    NT_TW: "荃灣",
    NT_TM: "屯門",
    NT_YL: "元朗",
    NT_N: "北區",
    NT_TP: "大埔",
    NT_ST: "沙田",
    NT_SK: "西貢",
    NT_Islands: "離島",
    address: "地址",
    tel_no: "電話",
    center_contact_person: "中心負責人姓名",
    opening_hours: "營業時間",
    map_settings: "地圖設定",
    google_map_url: "Google地圖連結",
    google_map: "Google地圖",
    latitude: "緯度",
    longitude: "經度",
    Categories: "分類",
    DefualThemes: "預設主題",
    Schedules: '開放時間表',
    Schedules_copy: '複製開放時間表',
    Schedules_copy_confrim: '確認要複製',
    PublicHolidayCalendar: "公眾假期日曆",
    Settings: '設定',
    Locations: "地點",
    Location: "地點",
    center: "中心",
    organization: "機構",
    Min: "最短預約時間",
    Max: "最長預約時間",
    Mins: "分鐘",
    Events: "活動",
    Event: "活動",
    Bookings: "預約",
    ViewDetails: "查看詳情",
    email_alert: "系統電郵通知",
    email_recipients: "收件人",
    email_recipients_exp: "請用逗號分隔多個電郵地址",
    email_lang: "電郵語言",
    backtoHome: "返回主頁",

    //Locker//
    DeviceCode: '裝置編號:',
    TextDescription: '文字描述',
    BookingSettings: '預約設定',
    Calendar: '日曆',
    images: '圖片',
    Active: '啟用',
    ManualApproval: '手動批核',
    Locked: '鎖定',
    Cells: '儲存格',

    //Member//
    ChineseName: '中文姓名',
    PolicyChecked: '已確認條款及細則',
    Locale: '語言設定',
    English: '英文',
    Chinese: '中文',
    StartDate: '委任生效日期',
    EndDate: '委任結束日期',
    AccessRight: '訪問權限',
    Roles: '職位',
    ResetPassword: '重設密碼',
    MyPass: '我的QR Code',

    //Member GP//
    MemberGPname: '會員分類名稱',

    //Space//
    AddSpace: '新增房間',
    EditSpace: '編輯房間',
    AutoApprove: '自動批核',
    Bookable: '可預約',
    Dependencies: '關聯房間',
    Facilities: '設備',
    Type: '類型',
    FacilityName: '設備名稱',
    Space_rental: '租借場地',
    OtherFacilities: '其他設施',
    space_available: '可供借用場地',
    space_categories: "房間分類",
    space_usage_theme: "房間主題",
    backtoCenter: "返回中心頁面",
    no_space: "我們正在準備中！尚未有場地上架。",
    //SpaceType//
    AddSpaceType: '新增房間類別',
    EditSpaceType: '編輯房間類別',


    //Space - 21C//
    active_space: "生效房間",
    total_space: "所有房間",
    add_theme: "新增主題",
    edit_theme: "編輯主題",
    add_category: "新增分類",
    edit_category: "編輯分類",
    add_space: "新增房間",
    space_settings: "房間設定",
    basic_settings: "基本設定",
    advanced_settings: "進階設定",
    space_name: "房間名稱",
    remarks: "備註",
    capacity: "可容納人數",
    capacity_exp: '可容納人數將會限制房間預訂者邀請參與者總數，如沒有填寫或輸入"0"即代表房間並沒有限制使用人數',
    booking_qty_title: "每時段多座位預約",
    booking_qty_title2: "(適用於房間座位數量管理例如：自修室)",
    booking_qty: "每時段坐位名額",
    booking_qty_min_alert: "啟用時，此數值必須至少為2。",
    booking_qty_capacity_alert: "此數值必須小於或等於房間可容納人數。",
    booking_qty_exp: "同一時間段內，同一預約人只可預約一次此房間。",
    booking_qty_walkin_disabled: "當此功能開啟，此房間不適用參與者功能。",
    venue_size: "房間面積",
    facilities_included: "已包括設備",
    additional_facilities_available_for_rent: "可額外借用設備",
    no_facility_found:
      "此中心沒有提供可額外借用設備選擇",
    booking_settings: "預約設定",
    defual_space_usage_themes: "預設房間主題",
    usage_theme: "主題",
    booking_restrict: "預約限制",
    no_restrict_staff: "中心職員帳號不在此限",
    days_in_advance: "未來可預約日數",
    no_slot_available: '沒有可預約的時段',
    min: "最短預約時間",
    max: "最長預約時間",
    increment: "時段長度",
    mins: "分鐘",
    space_status: "房間狀態",
    auto_approve: "自動批核預約",
    auto_approve_exp:
      "如開啓，中心職員無需手動批核預約。當會員提交預約房間申請，申請會自動確認。",
    auto_approve_on: "自動批核預約: 開啓",
    auto_approve_off: "自動批核預約: 關閉",
    staff_only: "只限職員預約",
    staff_only_exp: "如開啓，此房間只限中心職員預約。",
    booking_mode: "預約功能",
    booking_mode_exp:
      "此房間無需預約。中心職員可於任何時間使用QRcode進入房間；其他會員可於開放時間內用QRcode進入房間（如有設定開放時間）。",
    door_lock_settings: "門鎖設定",
    smart_lock: "智能門鎖",
    booking_records: "預約紀錄",
    calendar: "日曆",
    event: "活動",
    public_holiday_calendar: "公眾假期日曆",
    duration: "租借時長",
    space_facility: "房間設備",
    space_facility_add: "新增房間設備",
    space_delete_locked: "此房間已連接智能門鎖，用戶無法自行刪除。",
    calendar_delete_locked: "此時間表已連接智能門鎖，用戶無法自行刪除。",


    //Facility
    Facility: {
      pricing: "設施租借費用",
      free: "免費借用",
      fee: "需額外收費(請查詢)",
      input: "輸入費用",
      reminder: "因中心設備數量有限，你所剔選的設備並不代表已保留，屆時由中心職員當天安排為準，如有任何需要請聯絡中心職員查詢。",
    },

    //User//
    User: '用戶',
    AdminUser: '管理員用戶',
    user_type: "用戶類型",

    //Booking//
    created_time: '建立時間',
    booked_slot: '已預約時段',
    approve: '批核',
    reject: '駁回',
    booking_approval: '預約批核',
    checkin: '簽到',
    absent: '缺席',
    invite_frd: '邀請朋友共同解鎖/使用房間',
    copy_invite_msg: '複製邀請訊息',
    share_whatsapp: '分享到WhatsApp',
    cancel_booking: '取消預約',
    cancel_booking_confirm: '確定取消此預約?',
    cancel_booking_reason: {
      reason: '我要取消預約，原因是：',
      event_cancelled: '活動已取消',
      incorrect_booking: '預約內容錯了',
      unexpected_matter: '我有突發事情，不能前往',
      other_location: '我有另一個更合適的場地',
      other: '其他原因，請註明',
      other_reason: '取消預約原因',
    },
    cancel_booking_byStaff: '預約已被中心職員取消',
    booking_remind_msg: {
      days_after1: '即將在',
      days_after2: '日後開始!',
      starting_soon: '即將開始!',
      checkin_now: '立即簽到',
      checkin_done: '預約已簽到',
      checkin_no: '沒有預約簽到紀錄',
    },
    export_booking: '匯出預約紀錄',
    export_booking_desc: '匯出選定日期範圍內的預約紀錄',
    export_booking_incl_checkin: "包括參與者簽到紀錄",
    export_booking_incl_checkin_alrt: "啟用此功能可能會增加下載檔案所需時間。",
    select_booking: '選擇預約',

    //Doors//
    locks_control: '門鎖控制',
    passcode: '開門密碼',
    door_log: '開門記錄',
    checkin_log: '簽到紀錄',
    tablet_control: '平版電腦控制',
    tablet: '平版電腦',
    poster_display: '海報顯示',
    file_name: '文件名稱',
    delete_file: '刪除文件',
    unlock: '開鎖',

    Filter: {
      filter: '篩選',
      all: '全部',
      district: '地區',
      cat_name: '分類名稱',
      cat_all: '全部分類',
      capacity: '容納人數',
      noSpecify: '沒有指定',
      org_name: '機構名稱',
      center_name: '中心名稱',
      clear: '清除',
      any_area: '任何區域',
      any_district: '任何地區',
      date: '可預約日期/時間',
    },

    findSpace: {
      whatActivity: "你即將進行什麼活動？",
      where: "即將進行活動的地區為？",
      ppl: "即將進行活動的人數是？",
      when: "即將進行活動的時間是？",
      notDecided: "暫未有決定，我想查詢所有場地",
      ppl_above_zh: "以上",
      ppl_above_en: "",
      select_date: "選擇日期",
      start_time: "活動開始時間",
      any_time: "任何時間",
      search_result: "搜尋結果",
      search_again: "重新搜尋",

      //error
      error_selectOne: "請最少選擇一項",
    },

  },
  zh_cn: {
    search: '搜寻',
    delete: '删除',
    delete_confirm: '您确定要删除此项目吗？',
    close: '关闭',
    save: '储存',
    add: '新增',
    edit: '编辑',
    export: '汇出',
    actions: '动作',
    cancel: "返回",//for cancel booking, "cancel" is confused. changed to "back"
    confirm: '确认',
    email: '电邮',
    name: '名称',
    code: '编号',
    username: '用户名称',
    date: '日期',
    time: '时间',
    member: '会员',
    locker_bookings: '储物柜预约',
    password: '密码',
    change_password: '更改密码',
    logout: "登出",
    login: "登入",
    optional: "选填",
    share: "分享",
    linkCopied: "已复制连结",
    copied: "已复制",
    other_language: '其他语言',
    enable: '启用',
    disable: '停用',
    active: "生效",
    inactive: "无效",
    no_result: "没有乎合的结果",
    change: "更改",
    day: '日',
    or: '或',
    next: '下一步',
    back: '上一页',
    pls_select: '请选择',
    duplicate: '复制',
    na: '不适用',
    copy_instruction: '复制以下文字',
    copy_selected: '已选择文字',
    On: "开启",
    Off: "关闭",

    en: '英文',
    zh_cn: '简体中文',

    pagenotfound: '找不到页面',
    notfound_exp: '您要查找的页面不存在。 它可能已被移动或删除。',
    user_notfound: '找不到用户',
    backhome: '回到主页',
    show_more: '显示更多',
    hide: '隐藏',

    //error message
    error: {
      'integrity.error': '不能删除：此项目与其他项目有连结',
      'already.accepted': '您已曾经接受此活动邀请，无法重复接受。',
      'capacity.exceeded': '无法接受邀请，此活动已达房间可容纳人数上限。',
      'booking.cancelled': '预约已被取消，无法进行此操作。',
      'booking.ended': '预约已结束，无法进行此操作。',
      'not.available': '此时段已无法预约，请重新选择。',
      'duplicate.bookings': '预约人不可重覆预约同一时段',
    },

    thinkdesks: {
      Yes: "是",
      No: "否",
      time: "时间",
      duration: "时长",
      set_special_day: "设置特殊日子",
      open: "开放时间",
      public_holiday_open: "公众假期有不同开放时间?",
      closed: "休息",
      special_day: '特殊日子',
      set_schedule: "设置时间表",
      from: "由",
      from_placeholder: "生效日期(必填)",
      to: "至",
      to_placeholder: "如直至永远，请留空",
      schedule_info: "时间表资讯",
      copy_to: "复制至",
      select_all: "全选",
      mon: "周一",
      tue: "周二",
      wed: "周三",
      thu: "周四",
      fri: "周五",
      sat: "周六",
      sun: "周日",
      public_holiday: "公众假期",
      regular_schedule: '常规时间表',
      selected_day: "已选择日期",
      special_in_use: "正使用特殊开放时间",
      onwards: "起",
      applicable_date: "适用日期",

      //error message
      exceed_booking_hour: "每次最多预约",
    },

    schecule_applied_space: "已套用房间",

    interval: {
      days: '日',
      hours: '小时',
      hour: '小时',
      mins: '分',
      secs: '秒',
      from: '由',
      to: '至',
    },


    filterObject: {
      _: '筛选项目',
      all_time: '所有日期',
      today: '今天',
      yesterday: '昨天',
      day3: '最近3天',
      day14: '最近14天',
      day7: '最近7天',
      custom_time: '自订',
      greaterThan: '大于',
      lessThan: '小于',
      lessThan_equal: '小于/等于',
      greaterThan_equal: '大于/等于',
    },

    //Menu//
    Home: "主页",
    SpaceBookings: '房间预约',
    favourites_space: '我的最爱',
    MyBookings: '我的预约',
    Profile: "我的帐户",
    AllCenters: "中心一览",
    MyCenters: "我的中心",
    MySpaces: "我的房间",
    Centers: "中心",
    Spaces: "房间",
    Space: "房间",
    BookingManagement: "管理预约",
    Manage: "管理",

    //Home//
    HomeGreeting1: "Hello!",
    HomeGreeting2: "想搵咩地方?",
    NearbyCenters: "附近中心",
    Centers_random: "各区中心",
    ViewMap: "查看地图",
    ViewAll: "查看全部",
    RecommendedSpaces: "推荐房间",
    SearchSpaces: "搜寻房间",

    //Status//
    bookingStatus: {
      status: '预约状态',
      pending: '待批核',
      cancelled: '已取消',
      approved: '已确认',
      rejected: '已拒绝',
    },

    //My bookiong//
    UpComing: "近期预约",
    Past: "过往预约",
    AddToCalendar: "新增到日历",
    CenterInfo: "中心资料",
    Remarks: "备注",
    FacilitiesIncluded: "已包括设备",
    SpaceFacilities: "房间设备",
    AdditionalFacilitiesAvailableForRent: "可额外借用设备",
    RebookSameSpace: "预约相同房间",
    AdditionalFacilities: "额外借用设备",

    //blacklist//
    booking_blacklist: "由于你已缺席了超过2次或以上的房间预订，系统暂时封锁了你的预订功能，如需帮忙请联络中心职员查询。",


    //SpaceCard//
    Capacity: "可容纳",
    VenueSize: "面积",
    People: "人",

    //Booking dialog//
    Booking: '预约',
    sync_to_VP: '同步到VP',
    NotSelected: '未选择',
    SelectMember: '选择会员',
    StartTime: '选择时间',
    Duration: '租借时长',
    Book: '预约',
    Status: '状态',
    BookSpace: '预约房间',
    Lockers: '储物柜',
    Listview: '列表检视',
    Calendarview: '日历检视',
    Selectspacebook: '选择预约房间',
    Pending: '待批核',
    Rejected: '拒绝',
    Approved: '已批核',
    Cancelled: '已取消',
    SetSpecialDay: '设定特别日子',
    SetSchedule: '设定日程',
    RegularSchedule: '平常日子',
    SpecialDay: '特别日子',
    ApplicableDate: '生效日期由',
    Onwards: '开始',
    Selectedday: '已选日期',
    SpecialInuse: '特别使用时间',
    Closed: '不开放',
    From: '由',
    To: '至',
    ScheduleInfo: '日程详细',
    Mon: '星期一',
    Tue: '星期二',
    Wed: '星期三',
    Thu: '星期四',
    Fri: '星期五',
    Sat: '星期六',
    Sun: '星期日',
    Holiday: '公众假期',
    CopyTo: '复制至',
    SelectAll: '全选',
    Open: '开放',
    BookingDetails: "预约详情",
    Sync: "同步",
    DoYouNeedToRentAnyAdditionalFacilities: "是否需要借用额外设备",
    Yes: "是",
    No: "否",
    BookingPerson: "预约人",
    ContactPerson: "联络人",
    SameAsBookingPerson: "与预约人相同",
    SelectDateAndTime: "选择日期及时间",
    SelectTime: "请选择时段",
    time_available: "可选",
    time_unavailable: "不可选",
    time_selected: "已选",
    available_qty: "可预约",
    DateAndTime: "日期及时间",
    ConfirmTitleText: "请确认以下预约资料！",
    TermsAndConditions: "条款及细则",
    TermsAndConditions_space: "房间预约条款及细则",
    TermsAndConditions_space_exp: "如留空此栏，将会默认使用中心预设/系统预设条款及细则。",
    TermsAndConditions_centerDefault: "预约条款及细则 (中心预设)",
    TermsAndConditions_centerDefault_exp: "当房间没有设定条款及细则，会默认使用此中心预设条款及细则。如留空此栏，将会默认使用系统预设条款及细则。",
    BookingConfirmed: "已完成预约",
    waitApproval: "我们会尽快批核你的预约，请耐心等候。",
    QRCodeText: "请在签到时出示会员QR Code",
    usePasscode: '透过以下密码开门',
    participant_users: '使用者',
    participant: '参与者',
    walkin: '参与者(Walk-in)',
    numParticipants: '参与者人数',
    numParticipants_exp: '若此房间不会与其他使用者共用，请填写为 0。',
    numParticipants_max1: '*最多可邀请',
    numParticipants_max2: '位参与者',
    numParticipants_error_neg: '请输入正确的参与者人数',
    numParticipants_error_exceed: '参与者人数超出上限',
    numParticipants_list: '参与者名单',
    numParticipants_list_na_capacity: '房间设定可容纳人数为 1，参与者名单不适用。 ',
    numParticipants_list_na_maxBookings: '房间设定每时段可多座位预约，参与者名单不适用。 ',
    numParticipants_edit: '修改人数',
    numParticipants_edit_error: '无法修改参与者名单人数，已达房间最大可容纳人数',
    walkin_list: '参与者(Walk-in)名单',
    walkin_list_na_capacity: '房间设定可容纳人数为 1，参与者(Walk-in)名单不适用。 ',
    walkin_list_na_maxBookings: '房间设定每时段可多座位预约，参与者(Walk-in)名单不适用。 ',
    booking_participant_reminder: '您可予预约时段出示个人E-Passport（会员Qr Code）解锁此房间并进行签到。',

    //Booking invitation//
    login_tomo: '请先登入你的TO_MO账户',
    open_tomo_app: '开启TO_MO APP',
    tomo_app_not_installed: '尚未有TO_MO APP？ ',
    download_now: '立即下载',
    or_webLogin: '或使用网站登入',
    webLogin: '网站登入',
    invite_owner_error: '不能接受自己的活动邀请',
    invite_ended_error: '活动已结束',
    invite_cancelled_error: '活动已被取消',
    invite_exceeded_error: '此活动已达房间可容纳人数上限',
    invite_outsider_error: '抱歉，您不是此预约系统的服务对象，所以未能参与房间预订',


    //Booking dialog - snackbar//
    select_date_alert: "请选择日期及时间",
    select_facility_alert: "请选择房间设备",



    //Center//
    space_facilities: "房间设备",
    AddCenter: "新增中心",
    viewAllCenters: "查看全部中心",
    introduction: "介绍",
    ContactInfo: "联络资料",
    Area: "地区",
    HK: "港岛",
    KLN: "九龙",
    NT: "新界",
    HK_CS: "中西区",
    HK_WC: "湾仔",
    HK_E: "东区",
    HK_S: "南区",
    KLN_YTM: "油尖旺",
    KLN_SSP: "深水埗",
    KLN_KC: "九龙城",
    KLN_WTS: "黄大仙",
    KLN_KT: "观塘",
    NT_KT: "葵青",
    NT_TW: "荃湾",
    NT_TM: "屯门",
    NT_YL: "元朗",
    NT_N: "北区",
    NT_TP: "大埔",
    NT_ST: "沙田",
    NT_SK: "西贡",
    NT_Islands: "离岛",
    address: "地址",
    tel_no: "电话",
    center_contact_person: "中心负责人姓名",
    opening_hours: "营业时间",
    map_settings: "地图设定",
    google_map_url: "Google地图连结",
    google_map: "Google地图",
    latitude: "纬度",
    longitude: "经度",
    Categories: "分类",
    DefualThemes: "预设主题",
    Schedules: '开放时间表',
    Schedules_copy: '复制开放时间表',
    Schedules_copy_confrim: '确认要复制',
    PublicHolidayCalendar: "公众假期日历",
    Settings: '设定',
    Locations: "地点",
    Location: "地点",
    center: "中心",
    organization: "机构",
    Min: "最短预约时间",
    Max: "最长预约时间",
    Mins: "分钟",
    Events: "活动",
    Event: "活动",
    Bookings: "预约",
    ViewDetails: "查看详情",
    email_alert: "系统电邮通知",
    email_recipients: "收件人",
    email_recipients_exp: "请用逗号分隔多个电邮地址",
    email_lang: "电邮语言",
    backtoHome: "返回主页",

    //Locker//
    DeviceCode: '装置编号:',
    TextDescription: '文字描述',
    BookingSettings: '预约设定',
    Calendar: '日历',
    images: '图片',
    Active: '启用',
    ManualApproval: '手动批核',
    Locked: '锁定',
    Cells: '储存格',

    //Member//
    ChineseName: '中文姓名',
    PolicyChecked: '已确认条款及细则',
    Locale: '语言设定',
    English: '英文',
    Chinese: '中文',
    StartDate: '委任生效日期',
    EndDate: '委任结束日期',
    AccessRight: '访问权限',
    Roles: '职位',
    ResetPassword: '重设密码',
    MyPass: '我的QR Code',
    //Member GP//
    MemberGPname: '会员分类名称',

    //Space//
    AddSpace: '新增房间',
    EditSpace: '编辑房间',
    AutoApprove: '自动批核',
    Bookable: '可预约',
    Dependencies: '关联房间',
    Facilities: '设备',
    Type: '类型',
    FacilityName: '设备名称',
    Space_rental: '租借场地',
    OtherFacilities: '其他设施',
    space_available: '可供借用场地',
    space_categories: "房间分类",
    space_usage_theme: "房间主题",
    backtoCenter: "返回中心页面",
    no_space: "我们正在准备中！尚未有场地上架。",
    //SpaceType//
    AddSpaceType: '新增房间类别',
    EditSpaceType: '编辑房间类别',


    //Space - 21C//
    active_space: "生效房间",
    total_space: "所有房间",
    add_theme: "新增主题",
    edit_theme: "编辑主题",
    add_category: "新增分类",
    edit_category: "编辑分类",
    add_space: "新增房间",
    space_settings: "房间设定",
    basic_settings: "基本设定",
    advanced_settings: "进阶设定",
    space_name: "房间名称",
    remarks: "备注",
    capacity: "可容纳人数",
    capacity_exp: '可容纳人数将会限制房间预订者邀请参与者总数，如没有填写或输入"0"即代表房间并没有限制使用人数',
    booking_qty_title: "每时段多座位预约",
    booking_qty_title2: "(适用于房间座位数量管理例如：自修室)",
    booking_qty: "每时段坐位名额",
    booking_qty_min_alert: "启用时，此数值必须至少为2。",
    booking_qty_capacity_alert: "此数值必须小于或等于房间可容纳人数。",
    booking_qty_exp: "同一时间段内，同一预约人只可预约一次此房间。",
    booking_qty_walkin_disabled: "当此功能开启，此房间不适用参与者功能。",
    venue_size: "房间面积",
    facilities_included: "已包括设备",
    additional_facilities_available_for_rent: "可额外借用设备",
    no_facility_found: "此中心没有提供可额外借用设备选择",
    booking_settings: "预约设定",
    defual_space_usage_themes: "预设房间主题",
    usage_theme: "主题",
    booking_restrict: "预约限制",
    no_restrict_staff: "中心职员帐号不在此限",
    days_in_advance: "未来可预约日期",
    no_slot_available: '没有可预约的时段',
    min: "最短预约时间",
    max: "最长预约时间",
    increment: "时段长度",
    mins: "分钟",
    space_status: "房间状态",
    auto_approve: "自动批核预约",
    auto_approve_exp:
      "如开启，中心职员无需手动批核预约。当会员提交预约房间申请，申请会自动确认。",
    auto_approve_on: "自动批核预约: 开启",
    auto_approve_off: "自动批核预约: 关闭",
    staff_only: "只限职员预约",
    staff_only_exp: "如开启，此房间只限中心职员预约。",
    booking_mode: "预约功能",
    booking_mode_exp:
      "此房间无需预约。中心职员可于任何时间使用QRcode进入房间；其他会员可于开放时间内用QRcode进入房间（如有设定开放时间）。",
    door_lock_settings: "门锁设定",
    smart_lock: "智能门锁",
    booking_records: "预约纪录",
    calendar: "日历",
    event: "活动",
    public_holiday_calendar: "公众假期日历",
    duration: "租借时长",
    space_facility: "房间设备",
    space_facility_add: "新增房间设备",
    space_delete_locked: "此房间已连接智能门锁，用户无法自行删除。",
    calendar_delete_locked: "此时间表已连接智能门锁，用户无法自行删除。",

    // Facility
    Facility: {
      pricing: "设施租借费用",
      free: "免费借用",
      fee: "需额外收费(请查询)",
      input: "输入费用",
      reminder: "因中心设备数量有限，你所剔选的设备并不代表已保留，届时由中心职员当天安排为准，如有任何需要请联络中心职员查询。",
    },

    //User//
    User: '用户',
    AdminUser: '管理员用户',
    user_type: "用户类型",

    //Booking//
    created_time: '建立时间',
    booked_slot: '已预订时段',
    approve: '批核',
    reject: '驳回',
    booking_approval: '预约批核',
    checkin: '签到',
    absent: '缺席',
    invite_frd: '邀请朋友共同解锁/使用房间',
    copy_invite_msg: '复制邀请讯息',
    share_whatsapp: '分享到WhatsApp',
    cancel_booking: '取消预约',
    cancel_booking_confirm: '确定取消此预约?',
    cancel_booking_reason: {
      reason: '我要取消预约，原因是：',
      event_cancelled: '活动已取消',
      incorrect_booking: '预约内容错了',
      unexpected_matter: '我有突发事情，不能前往',
      other_location: '我有另一个更合适的场地',
      other: '其他原因，请注明',
      other_reason: '取消预约原因',
    },
    cancel_booking_byStaff: '预约已被中心职员取消',
    booking_remind_msg: {
      days_after1: '即将在',
      days_after2: '日后开始!',
      starting_soon: '即将开始!',
      checkin_now: '立即签到',
      checkin_done: '预约已签到',
      checkin_no: '没有预约签到纪录',
    },
    export_booking: '汇出预约纪录',
    export_booking_desc: '汇出选定日期范围内的预约纪录',
    export_booking_incl_checkin: "包括参与者签到纪录",
    export_booking_incl_checkin_alrt: "启用此功能可能会增加下载档案所需时间。",
    select_booking: '选择预约',



    //Doors//
    locks_control: '门锁控制',
    passcode: '开门密码',
    door_log: '开门记录',
    checkin_log: '签到纪录',
    tablet_control: '平板电脑控制',
    tablet: '平板电脑',
    poster_display: '海报显示',
    file_name: '文件名称',
    delete_file: '删除文件',
    unlock: '开锁',

    Filter: {
      filter: '筛选',
      all: '全部',
      district: '地区',
      cat_name: '分类名称',
      cat_all: '全部分类',
      capacity: '容纳人数',
      noSpecify: '没有指定',
      org_name: '机构名称',
      center_name: '中心名称',
      clear: '清除',
      any_area: '任何区域',
      any_district: '任何地区',
      date: '可预约日期/时间',
    },

    findSpace: {
      whatActivity: "你即将进行什么活动？",
      where: "即将进行活动的地区为？",
      ppl: "即将进行活动的人数是？",
      when: "即将进行活动的时间是？",
      notDecided: "暂未有决定，我想查询所有场地",
      ppl_above_zh: "以上",
      ppl_above_en: "",
      select_date: "选择日期",
      start_time: "活动开始时间",
      any_time: "任何时间",
      search_result: "搜寻结果",
      search_again: "重新搜寻",

      //error
      error_selectOne: "请最少选择一项",
    },
  }
};

export let _common = Object.assign({}, Translate.zh_hk);
